import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { Avaliacao } from "model/solicitacao/avaliacao/Avaliacao";
import { AvaliacaoDTO } from "model/solicitacao/avaliacao/AvaliacaoDTO";
import { CriacaoComentarioDTO } from "model/solicitacao/comentario/CriacaoComentarioDTO";
import { ApiAvaliacao } from "service/api/avaliacao/ApiAvaliacao";
import { ApiSolicitacoes } from "service/api/solicitacao/ApiSolicitacoes";
import { ErrosUtils } from "util/ErrosUtils";
import { MarkdownUtil } from "util/markdown/MarkdownUtil";


class ListaAction {
  /**
   * Limpa os dados e deixa pronto para haver a requisição dos dados
   */
  static readonly iniciar = createAction('Avaliacao/listar/iniciar');

  static readonly carregarAvaliacoes = createAsyncThunk(
    'Avaliacao/listar/carregarAvaliacoes',
    async (idSolicitacao: number, {rejectWithValue}) => {
      try {
        return await ApiAvaliacao.getAvaliacoesByIdSolicitacao(idSolicitacao);
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  );

  static readonly incluirAvaliacao = createAction<Avaliacao>('Avaliacao/listar/incluirAvaliacao');
}


class FormularioAction {
  static readonly iniciar = createAction('Avaliacao/formulario/iniciar');

  static readonly avaliar = (idSolicitacao: number, nota: number, comentario?: string) => {
    const avaliarSolicitacao = () => {
      const dto: AvaliacaoDTO = {
        nota: nota,
        comentario: MarkdownUtil.toMarkdownOrUndefined(comentario)
      }

      return ApiAvaliacao.avaliarSolicitacao(idSolicitacao, dto);
    }

    return FormularioAction._enviar(avaliarSolicitacao);
  }

  static readonly reabrirSolicitacao = (idSolicitacao: number, comentario: string) => {
    const reabrirSolicitacao = () => {
      const dto: CriacaoComentarioDTO = {
        mensagem: MarkdownUtil.toMarkdown(comentario),
        idsAnexos: []
      }

      return ApiSolicitacoes.reabrirSolicitacao(idSolicitacao, dto);
    }

    return FormularioAction._enviar(reabrirSolicitacao);
  }

  static readonly _enviar = createAsyncThunk(
    'Avaliacao/formulario/enviar',
    async (requisitar: () => Promise<any>, {rejectWithValue}) => {
      try {
        return await requisitar();
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  );
}


export class AvaliacaoAction {
  static readonly lista = ListaAction;
  static readonly formulario = FormularioAction;
}